"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChipStaticContainer = exports.ChipClickableContainer = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _context = require("../context");

var _utils = require("../utils");

var _constants = require("./constants");

var _interfaces = require("./interfaces");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ChipStaticContainer = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterProps)(['colorScheme', 'backgroundColor', 'size'])
})(function (_ref) {
  var theme = _ref.theme,
      colorScheme = _ref.colorScheme,
      backgroundColorProp = _ref.backgroundColor,
      size = _ref.size;
  var backgroundColor = colorScheme === _interfaces.ChipColorScheme.Default ? _constants.BACKGROUND_COLOR_LIGHT_SCHEME[backgroundColorProp] : _constants.BACKGROUND_COLOR_DARK_SCHEME[backgroundColorProp];
  var foregroundColor = colorScheme === _interfaces.ChipColorScheme.Default ? _constants.FOREGROUND_COLOR_LIGHT_SCHEME : _constants.FOREGROUND_COLOR_DARK_SCHEME;
  var height = size === _interfaces.ChipSize.Default ? _constants.CONTAINER_HEIGHT : _constants.CONTAINER_HEIGHT_SMALL;
  return {
    backgroundColor: theme.selectors.color(backgroundColor),
    color: theme.selectors.color(foregroundColor),
    width: 'max-content',
    maxWidth: '100%',
    height: height
  };
});
exports.ChipStaticContainer = ChipStaticContainer;
var ChipClickableContainer = (0, _context.styledWithTheme)('button', {
  shouldForwardProp: (0, _utils.filterProps)(['colorScheme', 'isSelected', 'size'])
})(function (_ref2) {
  var theme = _ref2.theme,
      colorScheme = _ref2.colorScheme,
      isSelected = _ref2.isSelected,
      size = _ref2.size;
  var isSelectable = isSelected !== undefined;
  var variant = !isSelectable || isSelected === false ? _interfaces.ChipVariant.Outlined : _interfaces.ChipVariant.Filled;
  var backgroundColor = colorScheme === _interfaces.ChipColorScheme.Default ? _constants.BACKGROUND_COLOR_CLICKABLE_LIGHT_SCHEME[variant] : _constants.BACKGROUND_COLOR_CLICKABLE_DARK_SCHEME[variant];
  var hoverBackgroundColor = colorScheme === _interfaces.ChipColorScheme.Default ? _constants.BACKGROUND_COLOR_CLICKABLE_HOVER_LIGHT_SCHEME[variant] : _constants.BACKGROUND_COLOR_CLICKABLE_HOVER_DARK_SCHEME[variant];
  var focusBackgroundColor = colorScheme === _interfaces.ChipColorScheme.Default ? _constants.BACKGROUND_COLOR_CLICKABLE_FOCUS_LIGHT_SCHEME[variant] : _constants.BACKGROUND_COLOR_CLICKABLE_FOCUS_DARK_SCHEME[variant];
  var borderColor = colorScheme === _interfaces.ChipColorScheme.Default ? _constants.BORDER_COLOR_LIGHT_SCHEME[variant] : _constants.BORDER_COLOR_DARK_SCHEME[variant];
  var hoverBorderColor = variant === _interfaces.ChipVariant.Outlined ? borderColor : hoverBackgroundColor;
  var focusBorderColor = variant === _interfaces.ChipVariant.Outlined ? borderColor : focusBackgroundColor;
  var outlineColor = colorScheme === _interfaces.ChipColorScheme.Default ? _constants.OUTLINE_COLOR_LIGHT_SCHEME : _constants.OUTLINE_COLOR_DARK_SCHEME;
  var foregroundColor = colorScheme === _interfaces.ChipColorScheme.Default ? _constants.FOREGROUND_COLOR_CLICKABLE_LIGHT_SCHEME[variant] : _constants.FOREGROUND_COLOR_CLICKABLE_DARK_SCHEME[variant];
  var hoverForegroundColor = colorScheme === _interfaces.ChipColorScheme.Default ? _constants.FOREGROUND_COLOR_CLICKABLE_HOVER_LIGHT_SCHEME[variant] : _constants.FOREGROUND_COLOR_CLICKABLE_HOVER_DARK_SCHEME[variant];
  var focusForegroundColor = colorScheme === _interfaces.ChipColorScheme.Default ? _constants.FOREGROUND_COLOR_CLICKABLE_FOCUS_LIGHT_SCHEME[variant] : _constants.FOREGROUND_COLOR_CLICKABLE_FOCUS_DARK_SCHEME[variant];
  var highContrastStyle = theme.isInHighContrast && isSelected && {
    outlineStyle: 'solid',
    outlineOffset: '-4px'
  };
  var height = size === _interfaces.ChipSize.Default ? _constants.CONTAINER_HEIGHT : _constants.CONTAINER_HEIGHT_SMALL;
  return _objectSpread(_objectSpread({
    position: 'relative',
    backgroundColor: theme.selectors.color(backgroundColor),
    width: 'max-content',
    maxWidth: '100%',
    height: height,
    padding: 0,
    margin: 0,
    outline: 'none',
    borderStyle: 'solid',
    borderColor: theme.selectors.color(borderColor),
    borderWidth: _constants.BORDER_WIDTH,
    cursor: 'pointer',
    color: theme.selectors.color(foregroundColor)
  }, highContrastStyle), {}, {
    ':hover': {
      borderColor: theme.selectors.color(hoverBorderColor),
      backgroundColor: theme.selectors.color(hoverBackgroundColor),
      color: theme.selectors.color(hoverForegroundColor)
    },
    ':focus': {
      borderColor: theme.selectors.color(focusBorderColor),
      backgroundColor: theme.selectors.color(focusBackgroundColor),
      color: theme.selectors.color(focusForegroundColor)
    },
    ':focus:before': {
      content: '""',
      position: 'absolute',
      top: "-".concat(2 * _constants.BORDER_WIDTH + 1, "px"),
      bottom: "-".concat(2 * _constants.BORDER_WIDTH + 1, "px"),
      left: "-".concat(2 * _constants.BORDER_WIDTH + 1, "px"),
      right: "-".concat(2 * _constants.BORDER_WIDTH + 1, "px"),
      backgroundColor: 'transparent',
      borderWidth: _constants.BORDER_WIDTH,
      borderStyle: 'solid',
      borderColor: theme.selectors.color(outlineColor),
      transition: 'border 0.2s ease 0s'
    }
  });
});
exports.ChipClickableContainer = ChipClickableContainer;